import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import PageMeta from '../seo/PageMeta';
import { PLANS, PLAN_FAQ } from '../../config/plans';
import PlanFeatureCompare from '../billing/PlanFeatureCompare';
import UpgradeButton from '../billing/UpgradeButton';
import AuthContext from '../shared/AuthContext';
import ProductShell from '../marketing/ProductShell';
import MarketingLoginLink from '../marketing/MarketingLoginLink';

const PricingPage = () => {
  const [yearly, setYearly] = useState(false);
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <ProductShell
      title="Plans & checkout"
      eyebrow="Product · Pricing"
      lead="Compare Free, Pro, and Team. Upgrade Pro with Stripe checkout; start a collaborative Team workspace after sign-in."
      ctaLabel="Create free account"
      ctaTo="/login"
      ctaRedirect="/pricing"
    >
      <PageMeta />
      <div className="pricing-toggle">
        <button type="button" className={!yearly ? 'active' : ''} onClick={() => setYearly(false)}>Monthly</button>
        <button type="button" className={yearly ? 'active' : ''} onClick={() => setYearly(true)}>Yearly (save ~17%)</button>
      </div>
      <div className="marketing-grid">
        {PLANS.map((plan) => (
          <div key={plan.id} className={`marketing-card ${plan.highlight ? 'marketing-card-highlight' : ''}`}>
            <h3>{plan.name}</h3>
            <p className="pricing-amount">
              ${yearly ? plan.yearly : plan.monthly}
              <span>/{yearly ? 'year' : 'mo'}</span>
            </p>
            <p className="pricing-tagline">{plan.tagline}</p>
            <ul className="pricing-features">
              {plan.features.map((f) => (
                <li key={f}>{f}</li>
              ))}
            </ul>
            {plan.upgradeNote && (
              <p className="pricing-upgrade-note">{plan.upgradeNote}</p>
            )}
            {plan.checkout ? (
              <div style={{ marginTop: 12 }}>
                <UpgradeButton
                  plan={plan.planKey || 'pro'}
                  interval={yearly ? 'yearly' : 'monthly'}
                  useCheckoutPage={isAuthenticated}
                >
                  {isAuthenticated ? 'Go to checkout' : plan.cta}
                </UpgradeButton>
              </div>
            ) : plan.id === 'free' && !isAuthenticated ? (
              <MarketingLoginLink
                className="marketing-btn marketing-btn-primary"
                redirect="/pricing"
                style={{ marginTop: 12, display: 'inline-block' }}
              >
                {plan.cta}
              </MarketingLoginLink>
            ) : (
              <Link
                to={plan.ctaPath}
                className="marketing-btn marketing-btn-primary"
                style={{ marginTop: 12, display: 'inline-block' }}
              >
                {plan.cta}
              </Link>
            )}
          </div>
        ))}
      </div>
      <PlanFeatureCompare />
      <section className="pricing-faq">
        <h2>FAQ</h2>
        {PLAN_FAQ.map(({ q, a }) => (
          <details key={q} style={{ marginBottom: 12 }}>
            <summary>{q}</summary>
            <p>{a}</p>
          </details>
        ))}
      </section>
    </ProductShell>
  );
};

export default PricingPage;
